import React from 'react'

const ExploreBox1 = (props) => {
    const eventHandler=(value)=>{
        const container=document.getElementById('explore-container');
        console.log(container)
      //   const transNum=Number(value);
        container.style.transform=`translate(${value})`;
    }

    return (
        <>
        <div className="explore__header1">
            <ul>
                <li><a href="#" onClick={()=>eventHandler('0%')}>About</a></li>
               
                <li><a href="#" onClick={()=>eventHandler('-25%')}>Timeline</a></li>
                <li><a href="#" onClick={()=>eventHandler('-50%')}>Rules</a></li>
                <li><a href="#" onClick={()=>eventHandler('-74.5%')}>Contact Us</a></li>
            </ul>
            </div>  

           <div className="explore__big-container">
           <div className="explore__container1" id='explore-container'>
           <div className="tab_content one1"  id='details'>
                    <p> {props.first}</p>
                </div>
               {/*  */}
                <div className="tab_content one"  id='details'>
                     <div className="div1">
                         <h3>registration date :</h3>
                         <p>{props.date1}</p>
                     </div>
                     <div className="div1">
                         <h3>submission date :</h3>
                         <p>{props.date2}</p>
                     </div>
                     <div className="div1">
                         <h3>results date :</h3>
                         <p>{props.date3}</p>
                     </div>
                    
                </div>
                {/* tab */}
                <div className="tab_content two" id='rules'>
                        <div className="div1">
                            <h3> <span> {props.para1} </span></h3>
                            <h3> <span> {props.para2} </span></h3>
                            <h3> <span> {props.para3} </span></h3>
                            <h3> <span> {props.para4} </span></h3>
                            
                        </div>
                </div>
                {/* tab */}
                <div className="tab_content three">
                    <h2> {props.person} </h2>
                    <h4> {props.mail} </h4>
                    <p>contact: {props.contact} </p>
                </div>
            </div>
           </div>
      </>
    )
}

export default ExploreBox1
